module.exports = __webpack_public_path__ + "img/thanos-pal-v_Cc1qxKuBsmin.e236ce78.jpg";